import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { TASK_REQUEST_DONE, TASK_REQUEST_SKIP, TASK_REQUEST_ACCEPT, TASK_STATUS_REQUESTED, TASK_STATUS_ACCEPT } from 'components/player/task/constants';
import { setT } from 'helpers/translationUtilities';
import { reformatTinyMCEiframe } from 'helpers/utilities';
TaskModalContent.propTypes = {
    fields: PropTypes.object,
    onUpdate: PropTypes.func,
    isPlayerTask: PropTypes.bool.isRequired,
    action: PropTypes.string.isRequired,
    icon: PropTypes.string,
    closeModal: PropTypes.func,
    redirectToTasks: PropTypes.func
};
export default function TaskModalContent(_a) {
    var _b = _a.fields, fields = _b === void 0 ? null : _b, _c = _a.onUpdate, onUpdate = _c === void 0 ? null : _c, isPlayerTask = _a.isPlayerTask, action = _a.action, _d = _a.icon, icon = _d === void 0 ? '' : _d, _e = _a.closeModal, closeModal = _e === void 0 ? function () { } : _e, _f = _a.redirectToTasks, redirectToTasks = _f === void 0 ? function () { } : _f;
    useEffect(function () {
        reformatTinyMCEiframe('.modal-content__inner iframe');
    });
    if (!fields)
        return false;
    var type = isPlayerTask ? 1 : 2;
    var footerClasses = 'modal-content__footer modal-content__footer--task text-align-center text-align-right-md';
    function renderFooter() {
        if (fields.status === TASK_STATUS_REQUESTED || fields.status === TASK_STATUS_ACCEPT) {
            if (action === 'confirm') {
                return (React.createElement("div", { className: footerClasses },
                    React.createElement("button", { className: clsx('main-button main-button--lg', !fields.skippable && 'main-button--disabled'), onClick: fields.skippable ? function () { return onUpdate(fields.id, type, TASK_REQUEST_SKIP); } : null }, setT('skip')),
                    React.createElement("button", { className: "main-button main-button--inline main-button--lg", onClick: function () { return onUpdate(fields.id, type, TASK_REQUEST_ACCEPT); } }, setT('accept'))));
            }
            else if (action === 'finalize') {
                return (React.createElement("div", { className: footerClasses },
                    React.createElement("button", { className: "main-button main-button--inline main-button--lg main-button--secondary", onClick: function () { return closeModal(); } }, setT('close')),
                    React.createElement("button", { className: "main-button main-button--inline main-button--lg", onClick: function () { return onUpdate(fields.id, type, TASK_REQUEST_DONE); } }, setT('done'))));
            }
        }
        return (React.createElement("div", { className: footerClasses },
            React.createElement("button", { className: "main-button main-button--inline main-button--lg main-button--secondary", onClick: function () { return closeModal(); } }, setT('close'))));
    }
    return (React.createElement(Fragment, null,
        React.createElement("div", { className: "modal__content modal__content--fixed-footer" },
            React.createElement("div", { className: "modal__heading" },
                React.createElement("span", { className: "underlined-subtitle" }, setT('task'))),
            React.createElement("div", { className: "modal__content-wrap" },
                React.createElement("div", { className: "modal__header" }, icon ? React.createElement("div", { className: "icon icon--img icon--".concat(icon) }) : null),
                React.createElement("div", { className: "modal-content__inner text-align-left", dangerouslySetInnerHTML: { __html: fields.description } }))),
        renderFooter()));
}
